import { RadiologistStudyKeyImagesParams } from '@/api';

export const KEY_IMAGE_STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const KEY_IMAGE_POLLING_MAX_DURATION_MS = 2.5 * 60 * 1000; // 2.5 minutes

export const DEFAULT_KEY_IMAGE_PARAMS: RadiologistStudyKeyImagesParams = {
  key_images: true,
  return_images: true,
  return_urls: true,
};
